define('Components/AboutNavByDesireWidget/js/views/AboutNavByDesireWidgetInstanceView',[
    'jquery',
    'WidgetInstanceView',
    'app',
    'Components/AboutNavByDesireWidget/js/views/DesktopModalView',
    'template!Components/AboutNavByDesireWidget/templates/parent',
    'template!Components/AboutNavByDesireWidget/templates/child',
    'ProductBlockView',
    'InternalLinkView',
    'Siema',
],
    function($,
             WidgetInstanceView,
             app,
             DesktopModalView,
             templateParent,
             templateChild,
             ProductBlockView,
             InternalLinkView,
             Siema
    ){
    var ANBDW = 'ANBDW',
        PARENT = 'parent',
        slider;
        var TweenMax;
        // on demand TweenMax loading
        function RequireLibs(callback){
            if(!TweenMax) {
                require(['TweenMax'], function (TM) {
                    TweenMax = TM;
                    callback();
                });
            }else{
                callback();
            }
        }

        return WidgetInstanceView.extend({
            name: 'AboutNavByDesireWidgetInstanceView',
            events: {
                'click .ANBDW__list__item':'clickListItem',
                'click .ANBDW__list__pagination > div':'clickPagination',
                'click .ANBDW__list__arrows button':'clickPrevNext',
            },
            className: function(){
                var params = this.attributes.params,
                    template = params.template,
                    cl = 'AboutNavByDesireWidget'
                cl += ' '+cl+'--'+template+' '+ANBDW+' '+ANBDW+'--'+template;
                return cl;
            },
            getTemplate: function () {
                return this.model.p('template') === PARENT ?
                        templateParent:
                        templateChild;
            },
            afterRender:function(){
                var view = this,
                groupEl = view.el.querySelector('.ANBDW__list__group');
                InternalLinkView.initializeLinksOfView(view);
                if(app.isDesktop()){
                    RequireLibs(function(){
                        view.renderListDesktop();
                    })
                }else if(groupEl){
                    setTimeout(function(){
                        slider = new Siema({
                            selector: groupEl,
                            duration: 300,
                            easing: 'ease-out',
                            perPage: 1,
                            startIndex: 0,
                            draggable: true,
                            multipleDrag: true,
                            loop: true,
                            rtl: false,
                            onInit: onSliderChange,
                            onChange: onSliderChange,
                        })

                        function onSliderChange(){
                            var index = (slider ? slider.currentSlide : 0) || 0;
                            function toggleIndex(i,item){
                                var dataN = item.dataset.n;
                                dataN = dataN >= 0 ? parseInt(dataN) : i;
                                item.classList.toggle('active', dataN === index)
                            }
                            view.$('.ANBDW__list__item').each(toggleIndex);
                            view.$('.ANBDW__list__pagination > div').each(toggleIndex);
                            view.$('.ANBDW__list__products__wrapper').each(toggleIndex);
                        }
                    },10)

                    function onScrollMobile(){
                        var isDown = app.get('scrollTop')>100;
                        view.$('.ANBDW__list__product__cta').toggleClass('visible',isDown);
                    }
                    view.listenTo(app,'change:scrollTop',onScrollMobile);

                    ProductBlockView.initializeProductBlocksOfView(view);
                }
            },
            clickPrevNext:function(e){
                var direction = $(e.currentTarget).is('.slide-next');
                if(direction){
                    slider.next();
                }else{
                    slider.prev();
                }
            },
            renderListDesktop:function(){
                var view = this,
                    scrollTop = app.get('scrollTop'),
                    winH = app.get('winH'),
                    itemImageEls = view.$('.ANBDW__list__image'),
                    pointerEl = view.$('.ANBDW__list__pointer').get(0),
                    itemImageWrapperEls = view.$('.ANBDW__list__image__wrapper'),
                    destX,
                    destY,
                    parallaxRules = [1,-1,.75,-.75,.5],
                    scrollOffsetMouseY = 0;
                function refresh(event){
                    scrollTop = app.get('scrollTop');
                    var pointerY;
                    if(event.type ==='mousemove'){
                        destX = event.clientX;
                        destY = event.clientY;
                        pointerY = destY + scrollTop;
                        scrollOffsetMouseY = destY;
                    }else{
                        if(!destX){
                            destX = app.get('winW')/2;
                        }
                        destY = scrollTop;
                        pointerY = scrollOffsetMouseY + scrollTop
                    }
                    winH = app.get('winH');
                    TweenMax.to(pointerEl,.25,{
                        x:destX,
                        y:pointerY,
                        ease:Power1.easeOut,
                    })
                    var PUSH_FORCE = 0.6;
                    itemImageEls.each(function(index, el){
                        var bbox = el.getBoundingClientRect(),
                            bboxH = bbox.height,
                            bboxW = bbox.width,
                            centerX = bbox.right - bbox.width/2,
                            centerY = bbox.bottom - bbox.height/2,
                            dX = centerX-destX,
                            dY = centerY-destY,
                            dLength = Math.sqrt(dX*dX + dY*dY),
                            dAlpha = Math.atan2(dY, dX),
                            pushN = bboxW,
                            dLPush = (Math.cos(Math.PI*Math.max(0,1-Math.abs(dLength-pushN)/pushN))-1)/2,
                            pushForce = bboxH*PUSH_FORCE,
                            parallaxDeltaY = scrollTop-centerY-winH/2,
                            parallaxRule = parallaxRules[index%5],
                            parallaxOffsetY = Math.max(Math.abs(parallaxDeltaY/10),bboxH/10) * parallaxRule,
                            x = Math.round(-pushForce * dLPush * Math.cos(dAlpha)),
                            y = Math.round(-pushForce * dLPush * Math.sin(dAlpha)) + parallaxOffsetY,
                            wrapper = itemImageWrapperEls.get(index);
                        TweenMax.to(wrapper,1,{
                            x:x,
                            y:y,
                            ease:Power1.easeOut,
                        })
                        if(!bboxW){
                            app.$window.off('scroll',refresh);
                            app.$window.off('mousemove',refresh);
                        }
                    })
                }
                if(itemImageEls.length > 0){
                    app.$window.on('scroll',refresh);
                    app.$window.on('mousemove',refresh);
                }
            },
            clickListItem:function(e){
                var view = this;
                if(app.isDesktop()){
                        var id = e.currentTarget.dataset.id,
                            scrollTop = app.get('scrollTop'),
                        child = view.model.getChild(id),
                        modalView = new DesktopModalView(child);
                        view.$el.addClass('lock-scroll');
                    view.$('.ANBDW__modal_wrapper').append(modalView.$el);
                    modalView.once('close',function(){
                        view.$el.removeClass('lock-scroll');
                        app.scrollTop(scrollTop);
                        modalView.remove();
                    })
                    modalView.afterRender();
                }else{
                    view.$('.active .ANBDW__list__title').get(0).scrollIntoView({
                        alignToTop:true,
                        behavior:'smooth'
                    })
                }
            },
            clickPagination:function(e){
                var index = $(e.currentTarget).index();
                slider.goTo(index);
            }
        })
    }
);
